module.exports = __webpack_public_path__ + "img/Recommend_rlqd.a5a876d5.png";